<template>
  <div>
    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="استان:"
          label-for="example-input-1"
        >
          <MDDropdown
            :disabled="disabled"
            v-bind:group="4"
            v-model="$v.value.mdid4_province.$model"
            :state="validateState('mdid4_province')"
          ></MDDropdown>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن نام شرکت اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="شهر:"
          label-for="example-input-1"
        >
          <MDDropdown
            v-model="$v.value.mdid5_city.$model"
            v-bind:group="5"
            v-bind:parent="$v.value.mdid4_province.$model"
            :state="validateState('mdid4_province')"
            :disabled="disabled"
          ></MDDropdown>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن نام شرکت اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="کد پستی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            min="1000000000"
            mask="##########"
            @keyup="setENChars('postalCode')"
            v-model="$v.value.postalCode.$model"
            :state="validateState('postalCode')"
            :disabled="disabled"
          ></b-form-input>
          <b-form-invalid-feedback
            v-if="!$v.value.postalCode.required"
            id="input-1-live-feedback"
            >کد پستی را وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-if="!$v.value.postalCode.numbers"
            id="input-1-live-feedback"
            >کد پستی فقط باید عدد باشد</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.value.postalCode.minLength || !$v.value.postalCode.maxLength"
            id="input-1-live-feedback"
            >کد پستی باید 10 کاراکتر باشد</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="example-input-group-1"
          label="آدرس:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.address.$model"
            :state="validateState('address')"
            :disabled="disabled"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن آدرس اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<style>
.custom-select.is-valid,
.was-validated .custom-select:valid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%231BC5BD' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}
[type="number"] {
  width: 100%;
}

.v-select.vs--single.vs--searchable button svg{
  display: none;
}
</style>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { email, minLength, required,maxLength } from "vuelidate/lib/validators";
import MDDropdown from "../../components/MDDropdown";
const numbers = (value, vm) => !/[^0-9]/.test(value);
const national_card_number = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]{10}$/.test(value);

export default {
  mixins: [validationMixin],
  name: "UserAddress",
  props: ["value", "disabled", "validateInputswatcher"],
  data() {
    return {};
  },
  validations: {
    value: {
      mdid4_province: {
        required,
      },
      mdid5_city: {
        required,
      },
      address: {
        required,
        minLength: minLength(10),
      },
      postalCode: {
        required,
        numbers,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
    },
  },
  watch: {
    validateInputswatcher: function (newval, oldval) {
      this.validateInputs();
    },
  },
  components: {
    MDDropdown,
  },
  methods: {
    setENChars(field) {
      this.value[field] = this.value[field].toEnDigits();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    validateInputs() {
      this.$v.value.$touch();
    },
  },
  created() {},
};
</script>